/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-danger */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PageLoading from '../common/PageLoading';
import * as discussionActions from '../../actions/discussionActions';
import NotFound from '../common/NotFound';
import ArtistService from '../../services/artistService';
import Paging from '../common/Paging.js';
import ErrorMessage from '../common/ErrorMessage.js';
import moment from 'moment';
import ToastrService from '../../services/toastrService';
import * as qs from 'query-string';
import * as imageUtils from '../../utils/imageUtils';

class PostsPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.loadPosts = this.loadPosts.bind(this);
        this.createPost = this.createPost.bind(this);
        this.reportPost = this.reportPost.bind(this);
        this.deleteReportPost = this.deleteReportPost.bind(this);
        this.postReportTypes = ['Spam', 'Abusive', 'Offensive'];
        const params = qs.parse(this.props.location.search);
        this.state = {
            loading: false,
            loadingError: false,
            page: params.page || 1,
            message: '',
            pluggedIn: this.props.currentDiscussion ? this.props.currentDiscussion.Discussion.PluggedIn : false
        };
    }

    componentWillMount() {
        this.loadPosts(this.state.page);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillUpdate(nextProps, nextState) {
        const params = qs.parse(nextProps.location.search);
        if(params.page && params.page !== this.state.page) {
            this.setState({ page: params.page });
        }
        if(this.state.page !== nextState.page) {
            this.loadPosts(nextState.page);
        }
        if(nextProps.currentDiscussion && this.props.currentDiscussion !== nextProps.currentDiscussion) {
            this.setState({ pluggedIn: nextProps.currentDiscussion.Discussion.PluggedIn });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.page !== prevState.page || this.props.currentDiscussion !== prevProps.currentDiscussion) {
            window.scrollTo(0, 0);
        }
    }

    loadPosts(page = 1, forceReload = false) {
        const sectionLink = this.props.match.params.sectionLink;
        const discussionLink = this.props.match.params.discussionLink;
        this.setState({ loading: true, loadingError: false });
        //we're already checking all this in the action
        //if(forceReload || !this.props.currentDiscussion || this.props.currentDiscussion.Posts.Page !== page) {
            const currentProfileID = this.props.user && this.props.user.activeProfile ? this.props.user.activeProfile.ID : null;
            this.props.actions.getPosts(sectionLink, discussionLink, page, currentProfileID, forceReload)        
            .then(_ => {
                this.setState({
                    loading: false,
                    loadingError: false
                });
            })
            .catch(error => {
                this.setState({ loading: false, loadingError: true });
            });
        //}      
    }
    
    getThumbnail(imageUrl, roleType) {        
        const params = '?width=120&aspectw=1&quality=80&mode=crop&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    }

    createPost(event) {
        event.preventDefault();
        const sectionLink = this.props.match.params.sectionLink;
        const discussionLink = this.props.match.params.discussionLink;
        const post = { profileID: this.props.activeProfile.ID, message: this.state.message, pluggedIn: this.state.pluggedIn };
        this.props.actions.addPost(sectionLink, discussionLink, post)
            .then(_ => {    
                //check we're still on this discussion and we're on the last page
                const currentDiscussion = this.props.currentDiscussion;
                if(currentDiscussion && currentDiscussion.Section.Link === sectionLink && currentDiscussion.Discussion.Link === discussionLink && currentDiscussion.Posts.Page === currentDiscussion.Posts.TotalPages) {
                    //reload the list of posts, if we're at the limit for the current page, then request the next page, else re-request the current page           
                    if((currentDiscussion.Posts.Page * currentDiscussion.Posts.PageSize) > currentDiscussion.Posts.RowCount) {
                        //we're still at the current page, even with the extra post
                        this.loadPosts(currentDiscussion.Posts.Page, true);
                    }
                    else {
                        //load the next page, this will trigger a data reload
                        this.setState({ page: currentDiscussion.Posts.Page + 1 });
                    }
                }
                const toastrService = new ToastrService();
                toastrService.showSuccess('', 'Your reply has been posted!');
                this.setState({ message: '' });
            })
            .catch(error => {
                this.setState({ createPostError: error.message });
            });
    }

    reportPost(event, postID, reportType) {
        event.preventDefault();
        const toastrService = new ToastrService();
        this.props.actions.reportPost(postID, reportType, this.props.activeProfile.ID)
            .then(_ => {                    
                toastrService.showSuccess('', 'Thanks for reporting this to us!');
            })
            .catch(error => {
                toastrService.showError('', error.message);
            });
    }

    deleteReportPost(event, postID) {
        event.preventDefault();
        const toastrService = new ToastrService();
        this.props.actions.deleteReportPost(postID, this.props.activeProfile.ID)
            .then(_ => {                    
                toastrService.showSuccess('', 'You have removed your report');
            })
            .catch(error => {
                toastrService.showError('', error.message);
            });
    }

    render() {
        return (
            <div className="main">
                {
                    this.props.currentDiscussion && this.props.currentDiscussion.Posts.Items.length ?
                        <React.Fragment>                               
                            <MetaTags>      
                                <title>{`${this.props.currentDiscussion.Discussion.Title} - Discussion - LoudUp`}</title>   
                                <meta id="description" name="description" content={this.props.currentDiscussion.Posts.Items[0].Message.replace(/<\/?[^>]+(>|$)/g, '')} />   
                            </MetaTags>
                            <div className="container">
                                <div className="block-inner minimal-height">
                                    <h1 className="section-alt">Discussions</h1>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <div className="discbread">
                                                    <ol className="breadcrumb">
                                                        <li><Link to={'/Discussions'}>Discussions</Link></li>
                                                        <li className="active"><Link to={`/Discussions/${this.props.currentDiscussion.Section.Link}`}>{this.props.currentDiscussion.Section.Name}</Link></li>
                                                     </ol>
                                                </div>
                                                <div className="discfeed">
                                                    <h2>{this.props.currentDiscussion.Discussion.Title}</h2>
                                                    <p className="stat"><svg className="icon icn-view"><use xlinkHref="#icn-view" /></svg> <strong>{this.props.currentDiscussion.Discussion.ViewCount}</strong> · <svg className="icon icn-reply"><use xlinkHref="#icn-reply" /></svg> <strong>{this.props.currentDiscussion.Discussion.ReplyCount}</strong></p>
                                                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                                    {
                                                        this.props.currentDiscussion.Posts.Items.map(post => 
                                                            <div id={`post-${post.ID}`} className="post" key={post.ID}>
                                                                <div className="userthumb">
                                                                    <Link to={`/${post.AuthorUsername}`}>
                                                                        <img src={this.getThumbnail(post.AuthorImageUrl, post.AuthorRoleType)} alt={post.AuthorDisplayName} />
                                                                    </Link>
                                                                </div>
                                                                <div className="body">
                                                                    {
                                                                        !post.Deleted && post.ReportCount < 2 ?
                                                                            <React.Fragment>
                                                                                <p key={`post-${post.ID}`} dangerouslySetInnerHTML={{__html: post.Message}} />
                                                                                {
                                                                                    post.Videos && post.Videos.length ?
                                                                                        post.Videos.map((videoID, i) => 
                                                                                            <div key={i} className="embedded-video">
                                                                                                <iframe width="460" height="259" src={`//www.youtube.com/embed/${videoID}`} frameBorder="0" allowFullScreen />
                                                                                            </div>
                                                                                        )
                                                                                        : null
                                                                                }
                                                                            </React.Fragment>
                                                                            :
                                                                            <p>{post.Deleted ? 'This message has been deleted' : 'This post is currently hidden pending review'}</p>                                                                               
                                                                    }                                                                   
                                                                    <p className="by"><strong>{post.PostedDateText}</strong> by <strong><Link to={`/${post.AuthorUsername}`} className="btn-artist">{post.AuthorDisplayName}</Link></strong> ({ArtistService.getRoleTypeFriendlyName(post.AuthorRoleType)}) · POSTS: <strong>{post.AuthorPostCount}</strong></p>
                                                                    {
                                                                        this.props.user && this.props.user.Confirmed && this.props.activeProfile ?
                                                                        <div className="drop-report">
                                                                            <a href="#" className={`btn-text btn-report dropdown-toggle ${post.Reported ? 'active' : ''}`} aria-expanded="true" data-toggle="dropdown">
                                                                                {
                                                                                    <React.Fragment>
                                                                                        { post.Reported ? 'REPORTED' : 'REPORT' }
                                                                                        <span className="caret" />
                                                                                    </React.Fragment>
                                                                                }
                                                                            </a>
                                                                            {                                                                                
                                                                                <ul className="dropdown-menu" role="menu" aria-labelledby="dropmenu">
                                                                                    {
                                                                                        !post.Reported ?
                                                                                        this.postReportTypes.map(reportType =>
                                                                                            <li role="presentation" key={reportType}>
                                                                                                <a role="menuitem" href="#" onClick={(event) => this.reportPost(event, post.ID, reportType)}>{reportType}</a>
                                                                                            </li>
                                                                                        )
                                                                                        :
                                                                                        <li role="presentation">
                                                                                            <a role="menuitem" href="#" onClick={(event) => this.deleteReportPost(event, post.ID)}>Delete Report</a>
                                                                                        </li>
                                                                                    }
                                                                                </ul>
                                                                            }
                                                                        </div>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    <br />
                                                    {
                                                        this.props.currentDiscussion.Posts.Page === this.props.currentDiscussion.Posts.TotalPages ?
                                                            <div className="post-reply">
                                                                {
                                                                    !this.props.user || !this.props.user.Confirmed || !this.props.activeProfile ?
                                                                        <React.Fragment>
                                                                            <h2>Post a reply</h2>
                                                                            {
                                                                                !this.props.user ?
                                                                                    <p>Sorry, you need to <Link to={`/Account/Signup?returnUrl=${this.props.location.pathname}`}>sign up</Link> or <Link to={`/Account/Login?returnUrl=${this.props.location.pathname}`}>log in</Link> before you can join the discussion</p>
                                                                                :
                                                                                    !this.props.activeProfile ?
                                                                                        <p>Sorry, you need to <Link to="/Profile/Create">create a profile</Link> before you can join the discussion</p>
                                                                                        :
                                                                                        <p>Sorry, you need to confirm your email address before you can join the discussion</p>

                                                                            }                                                                            
                                                                        </React.Fragment>
                                                                    :
                                                                        <React.Fragment>
                                                                            <ErrorMessage error={this.state.createPostError} onClose={() => this.setState({ createPostError: null })} />
                                                                            <form id="frmNewPost" className="form-regular" onSubmit={this.createPost} style={{position: 'relative'}}>
                                                                                <div className="userthumb">
                                                                                    <img src={this.getThumbnail(this.props.activeProfile.DefaultImage, this.props.activeProfile.RoleType)} alt={this.props.activeProfile.DisplayName} />                                                                       
                                                                                </div>
                                                                                <h2>Post a reply</h2>
                                                                                <div className="form-group form-pre">
                                                                                    <textarea autoFocus cols="20" rows="4" className="form-control inputfield input-area showremainingchars" required placeholder="Write your message" value={this.state.message} onChange={(event) => this.setState({ message: event.target.value })} />
                                                                                </div>
                                                                                <span id="remainingChars" style={{float:'right', color:'#aaa'}} />
                                                                                <div className="post-plug">
                                                                                    <div className="checkbox">
                                                                                        <label>
                                                                                            <input type="checkbox" checked={this.state.pluggedIn} onChange={(e) => this.setState({pluggedIn: e.target.checked})}  />
                                                                                            Plug into this discussion to get updates
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group formspace">
                                                                                    <div className="row">
                                                                                        <div className="col-sm-3">
                                                                                            <input type="submit" value="POST REPLY" className="btn btn-primary btn-block btn-post" />
                                                                                        </div>
                                                                                        <div className="col-sm-9">
                                                                                            <p className="smalltype">Warning: posting abusive, offensive, or spam messages will result in being sent to a sad place far, far away where there are no beats or riffs or bass lines...or banned from here at the very least!</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </form> 
                                                                        </React.Fragment>                                                                        
                                                                }                                                            
                                                            </div>


                                                        : null
                                                    }
                                                    {
                                                        this.props.currentDiscussion.Posts.TotalPages > 1 ?
                                                            <Paging page={this.props.currentDiscussion.Posts.Page} totalPages={this.props.currentDiscussion.Posts.TotalPages} baseUrl={this.props.location.pathname} />
                                                            : null
                                                    }
                                                </div>                      
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    :
                        this.state.loading ? 
                            <PageLoading /> 
                            : 
                            this.state.loadingError ?
                                <div className="container">
                                    <div className="block-inner minimal-height">
                                        <ErrorMessage error="Sorry, something went wrong! Unable to load posts." />
                                    </div>
                                </div>
                                :   
                                <NotFound />
                }                
            </div>
        );
    }
}

PostsPage.propTypes = {
    location: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    currentDiscussion: PropTypes.object,
    activeProfile: PropTypes.object.isRequired,
    user: PropTypes.object,
    match: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    const sectionLink = ownProps.match.params.sectionLink;
    const discussionLink = ownProps.match.params.discussionLink;
    let currentDiscussion = null;
    const dateMinus1Minute = moment().subtract(1, 'minutes');
    if(state.discussions.currentDiscussion && state.discussions.currentDiscussion.Section.Link === sectionLink && state.discussions.currentDiscussion.Discussion.Link === discussionLink && new Date(state.discussions.currentDiscussion.lastLoaded) > dateMinus1Minute) {  
        currentDiscussion = state.discussions.currentDiscussion;
    }
        
    return { 
        user: state.account.user, 
        activeProfile: state.account.user ? state.account.user.activeProfile : null,
        currentDiscussion
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, discussionActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PostsPage);